import { Service } from './baseService';
import { getModelTypeIDAndEntityID } from '../config';

export const loginService = (credentials) => {
    return Service.post('/driver-auth/login', credentials, {
        params: getModelTypeIDAndEntityID(),
    });
};

export const ssoAuthService = (data) => {
    return Service.post(
        '/driver-auth/sso-auth',
        {},
        {
            params: { modelTypeID: data.modelTypeID, entityID: data.entityID },
            headers: {
                Authorization: `Bearer ${data.token}`,
            },
        }
    );
};

export const portalLoginService = (credentials) => {
    return Service.post('/driver-auth/portal-login', credentials);
};

export const submitInitialEmailService = (emailAddress) => {
    return Service.post('/driver-auth/initial-email-submit', {
        email: emailAddress,
        ...getModelTypeIDAndEntityID(),
    });
};

export const getDriverService = (data, scope) => {
    return Service.post('/driver-auth/get-driver', data, {
        // Prefer an explicitly-passed scope — e.g. the portal the driver selected on the login
        // screen before clicking "Forgot Password?", which is not yet persisted to localStorage.
        // Fall back to the stored scope for authenticated callers.
        params: scope || getModelTypeIDAndEntityID(),
    });
};

export const updateDriverService = (data, driverId) => {
    return Service.put(`/driver-auth/update-driver/${driverId}`, data);
};

export const checkPassword = (data, id) => {
    return Service.post(`/driver-auth/check-password/${id}`, { data });
};

export const sendForgetPasswordEmailService = (payload) => {
    return Service.post('/driver-auth/forgot-password-mail', payload);
};

export const loginImageService = () => {
    return Service.get('/auth/login-image');
};
